<template>
    <div>
        <div class="sub_title" @click="contentShow = !contentShow">
            기본정보
            <i class="el-icon-arrow-down" v-show="!contentShow"></i>
            <i class="el-icon-arrow-up" v-show="contentShow"></i>
        </div>
        <el-collapse-transition>
            <div class="c_table_wrap" v-show="contentShow">
                <table>
                    <colgroup>
                        <col width="200px;">
                        <col width="">
                    </colgroup>
                    <tbody>
                    <tr>
                        <td class="c_t_title">상품명</td>
                        <td>
                            <div class="d_block">
                                <el-input
                                    placeholder="상품명을 입력해주세요."
                                    v-model="name"
                                    type="text"
                                    @change="parentChange('name', name)"
                                />
                                <div class="input_error">{{validation.firstError('name') }}</div>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="c_t_title">브랜드</td>
                        <td>
                            <div class="d_block ">
                                <div class="pb10">
                                    <el-radio-group v-model="isLinkBrand" @change="changeBrandLink()">
                                        <el-radio :label="false" :value="false">직접 연결</el-radio>
                                        <el-radio :label="true" :value="true">브랜드 연결</el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-if="isLinkBrand" class="d_block d_block_item_basic">
                                    <div v-if="!checkBrandLink()">{{ brandData.b_name }}</div>
                                    <el-button type="primary" @click="saveBrandLink()" v-if="checkBrandLink()">브랜드 연결</el-button>
                                    <el-button type="primary ml10" @click="deleteBrandLink()" v-else>연결 해제</el-button>
                                </div>
                                <div v-else>
                                    <el-input v-model="brandName" @input="parentChange('brandName', brandName)"></el-input>
                                </div>
                                <div class="input_error">{{validation.firstError('brandName') }}</div>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="c_t_title">대표상품 등록</td>
                        <td>
                            <div class="d_block d_block_item_basic">
                                <el-radio-group v-model="mainItem" v-if="checkBrandLink()">
                                    <el-radio :label="false" :value="false" disabled>일반 상품</el-radio>
                                    <el-radio :label="true" :value="true" disabled>대표 상품</el-radio>
                                </el-radio-group>
                                <el-radio-group v-model="mainItem" @change="parentChange('mainItem', mainItem)" v-else>
                                    <el-radio :label="false" :value="false">일반 상품</el-radio>
                                    <el-radio :label="true" :value="true" :disabled="linkedItemOver == true" v-if="!checkBrandLink()">대표 상품</el-radio>
                                </el-radio-group>
                                <div class="ml20 d_block_item" v-if="checkLinkedItemOverShow()">*대표상품 최대 등록 수를 초과하여, 등록이 불가능합니다.(브랜드 당 최대 5개까지 등록가능)</div>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="c_t_title">링크</td>
                        <td>
                            <div class="d_block">
                                <el-input
                                    placeholder="링크를 입력해주세요."
                                    v-model="link"
                                    type="text"
                                    @change="parentChange('link', link)"
                                />
                                <div class="input_error">{{validation.firstError('link') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">상품코드 </td>
                        <td>
                            <div class="d_block">
                                <el-input v-model="sku" type="text" disabled/>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="c_t_title">관리코드</td>
                        <td>
                            <div class="d_block">
                                <el-input
                                    placeholder="관리코드를 입력해주세요."
                                    v-model="manageCode"
                                    type="text"
                                    @change="parentChange('manageCode', manageCode)"
                                />
                                <div class="input_error">{{validation.firstError('manageCode') }}</div>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="c_t_title">상품가격</td>
                        <td>
                            <div class="d_block">
                                <el-input
                                    placeholder="상품가격을 입력해주세요."
                                    v-model="price"
                                    type="number"
                                    @change="parentChange('price', price)"
                                />
                                <div class="input_error">{{validation.firstError('price') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">할인가격</td>
                        <td>
                            <div>
                                <el-radio-group v-model="discountUse" @change="parentChange('discountUse', discountUse)">
                                    <el-radio :label="1" value="1">사용</el-radio>
                                    <el-radio :label="0" value="0">미사용</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="d_block pt0" v-if="discountUse === 1">
                                <el-input
                                    placeholder="상품가격을 입력해주세요."
                                    v-model="discount"
                                    type="number"
                                    @change="parentChange('discount', discount)"
                                />
                                <div class="input_error">{{validation.firstError('discount') }}</div>
                            </div>
                        </td>
                    </tr>

                    </tbody>
                </table>
            </div>
        </el-collapse-transition>
    </div>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from '@/mixins/util';
import {fcComma} from "@/mixins/common";
import EventBus from "@/mixins/event-bus";

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    name: "ItemBasicLayout",
    mixins: [],
    components: {},
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        itemData: {
            default: () => {
            }, type: Object
        },
        itemClass: {default: null,},
        itemKey: {default: '',}
    },
    data() {
        return {
            contentShow: true,
            name: '',
            link: '',
            sku: '자동발급',
            manageCode: '',
            price: '',
            validatorArr: ['name', 'link', 'manageCode', 'price','discountUse','discount', 'brandName'],

            display: 0,
            discount : '',
            discountUse : 0,

            brandData: {},
            mainItem: false,
            linkedItemList: [],
            linkedItemOver: false,
            brandKey: 0,
            mainItemKey: 0,

            isLinkBrand: false,
            brandName: '',
        }
    },
    created() {
        if (this.isItemData()) {
            this.settingItemData();
        }
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('ItemBasicLayout')
        EventBus.$on('runSelectBrand', this.selectBrand)
        EventBus.$on('getLinkedBrand', this.getLinkedBrand)

    },
    beforeDestroy() {
        EventBus.$off("runSelectBrand")
        EventBus.$off("getLinkedBrand")

    },
    destroyed() {
    },
    computed: {},
    methods: {
        isItemData() {
            return !util.isEmpty(this.itemData);
        },
        settingItemData() {
            this.name = this.itemData.name;
            this.parentChange('name', this.name)
            this.link = this.itemData.link;
            this.parentChange('link', this.link)
            this.sku = this.itemData.sku;
            this.parentChange('sku', this.sku)
            this.manageCode = this.itemData.manageCode;
            this.parentChange('manageCode', this.manageCode)
            this.price = this.itemData.priceOrg;
            this.parentChange('price', this.price)
            this.discount = this.itemData.discount;
            this.parentChange('discount', this.discount)
            this.discountUse = this.itemData.discountUse;
            this.parentChange('discountUse', this.discountUse)
            this.brandData = this.itemData.brandData;
            this.parentChange('brandData', this.brandData)
            this.mainItem = this.itemData.brandData.is_main;
            this.parentChange('mainItem', this.mainItem)
            this.brandKey = this.itemData.brandKey;
            this.parentChange('brandKey', this.brandKey)
            this.brandName = this.itemData.brandName;
            this.parentChange('brandName', this.brandName)
            if(!util.isEmpty(this.brandKey)) {
                this.getLinkedBrand()
                this.isLinkBrand = true;
            }

         //   this.returnComma('price');
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
            EventBus.$emit('getMainItemKey',this.mainItemKey)
        },
        returnComma(name) {
            if(this[name] === '') {
                this[name] = '';
                return false;
            }
            let value = Number(String(this[name]).replace(/[^0-9]/g,''))
            this[name] = fcComma(value);
        },
        checkValidator() {
            this.$validate(['name', 'link', 'manageCode', 'price','discountUse','discount'])
        },
        checkBrandLink(){
            if(!util.isEmpty(this.brandData)){
                return false
            } else {
               return true
            }
        },
        checkLinkedItemOverShow(){
            if(util.isEmpty(this.brandData)){
                return false
            } else if(this.linkedItemOver == true){
                return true
            }
        },
        saveBrandLink(){
            this.$modal.show('item-brand-link-modal');
            this.parentChange('brandData', this.brandData)
            // this.parentChange('brandKey', this.brandData.b_idx)
            this.mainItem = false
            this.parentChange('mainItem', this.mainItem)
        },
        selectBrand(brand) {
            this.brandData = brand
            this.brandKey = brand.b_idx;
            this.brandName = brand.b_name;
            this.parentChange('brandData', this.brandData)
            this.parentChange('brandKey', this.brandKey)
            this.parentChange('brandName', this.brandName)
        },
        deleteBrandLink(){
            this.brandData = {}
            this.linkedItemList = []
            this.brandName = '';
            this.brandKey = null;
            this.mainItem = false
            this.parentChange('brandData', this.brandData)
            this.parentChange('mainItem', this.mainItem)
            this.parentChange('brandName', this.brandName)
            this.parentChange('brandKey', this.brandKey)
            // this.parentChange('selling', 0)
            // EventBus.$emit('changeSellingStatus', 0)
            EventBus.$emit('changeBrandDataStatus', {})
        },
        checkLinkedItemOver(list){
            if(list.length > 4){
                this.linkedItemOver = true
            } else {
                this.linkedItemOver = false
            }
        },

        getLinkedBrand() {
            let params = {ty : 'eot', bid : this.brandData.b_idx, main : 1 }
            try {
                this.$api.$item.getLinkedBrand(params).then(res => res.Data.Result).then(res => {
                    if(res.List.length == 0){
                        this.linkedItemList = []
                    } else{
                        this.linkedItemList = res.List;
                    }

                    util.Array.each(res.List, (data, index, arr) => {
                        if(data.i_idx == this.itemKey){
                            this.mainItemKey = data.bmi_idx
                        }
                    })
                    let withoutBrand = this._getLinkedBrandWithoutMy(this.linkedItemList);
                    this.checkLinkedItemOver(withoutBrand)
                })
            } catch (e) {
                console.log(e);
            }
        },
        _getLinkedBrandWithoutMy(list) {
            return list.filter(data => data.i_idx != this.itemKey);
        },
        changeBrandLink() {
            this.brandData = {};
            this.brandKey = null;
            this.mainItem = false;
            this.parentChange('brandKey', this.brandKey)
            this.parentChange('brandData', this.brandData)
            this.parentChange('mainItem', this.mainItem)
            if(this.isLinkBrand == true) {
                this.brandName = '';
                this.parentChange('brandName', this.brandName)
            }
        },
    },
    watch: {},
    validators: {
        discount: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.discountUse === 1){
                        if(util.isEmpty(value)) {
                            return '할인 금액을 입력해주세요.';
                        }else if(Number(this.price) <= Number(value)){
                            return '할인가격은 상품가격보다 작게 설정해주세요.';
                        }
                    }
                })
        },
        discountUse: function (value) {
            return Validator.value(value)
        },
        name: function (value) {
            return Validator.value(value)
                .required('상품명을 입력해주세요.');
        },
        link: function (value) {
            return Validator.value(value)
        },
        manageCode: function (value) {
            return Validator.value(value)
                .required('상품 관리코드을 입력해주세요.');
        },
        price: function (value) {
            return Validator.value(value)
                .required('상품 가격을 입력해주세요.')
                .custom(() => {
                    if(isNaN(value) && value != '') {
                        value = value.replace(/[^0-9]/g,'')
                    }
                    let price = this.price;
                    if(isNaN(price) && price != '') {
                        price = price.replace(/[^0-9]/g,'')
                    }
                    if(value <= 0) {
                        return '상품가격은 0보다 큰 값으로 입력해주세요.'
                    }
                })
        },
        brandName: function (value) {
            return Validator.value(value)
                .required('브랜드를 선택/입력해주세요.')
        },
    }
}
</script>

<style scoped>

</style>
